import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "14",
  height: "14",
  viewBox: "0 0 14 14",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M1.16666 6.99984C1.16666 3.77818 3.77833 1.1665 6.99999 1.1665C10.2217 1.1665 12.8333 3.77818 12.8333 6.99984C12.8333 10.2215 10.2217 12.8332 6.99999 12.8332C3.77833 12.8332 1.16666 10.2215 1.16666 6.99984ZM6.12499 5.39567C6.12499 5.15405 6.32087 4.95817 6.56249 4.95817H7.26755C7.60303 4.95817 7.87499 5.23013 7.87499 5.56561C7.87499 5.7687 7.77349 5.95836 7.6045 6.07102L7.27682 6.28947C6.83055 6.58699 6.56249 7.08786 6.56249 7.62422V7.729C6.56249 7.95199 6.7293 8.136 6.94495 8.16307H7.05503C7.27067 8.136 7.43749 7.95198 7.43749 7.729V7.62422C7.43749 7.38042 7.55933 7.15275 7.76219 7.01751L8.08986 6.79907C8.50227 6.52412 8.74999 6.06126 8.74999 5.56561C8.74999 4.74688 8.08628 4.08317 7.26755 4.08317H6.56249C5.83762 4.08317 5.24999 4.6708 5.24999 5.39567C5.24999 5.6373 5.44586 5.83317 5.68749 5.83317C5.92911 5.83317 6.12499 5.6373 6.12499 5.39567ZM6.99999 9.9165C6.67782 9.9165 6.41666 9.65534 6.41666 9.33317C6.41666 9.02957 6.64859 8.78014 6.94495 8.7524H7.05503C7.35139 8.78014 7.58332 9.02957 7.58332 9.33317C7.58332 9.65534 7.32216 9.9165 6.99999 9.9165Z",
      fill: "inherit"
    }, null, -1)
  ])))
}
export default { render: render }